import React, { lazy, Suspense } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { PersistGate } from 'redux-persist/lib/integration/react';

import eccoTheme from "./eccoTheme";

import { LoadingIndicatorProvider } from "./contexts/LoadingIndicator";
import SimpleRoute from "./Container/SimpleRoute";
import NestingRoute from "./Container/NestingRoute";
import Iframe from "./components/Iframe";

import store, { persistor } from "./redux/store";
import { Provider } from "react-redux";
import PanelRoute from "./Container/PanelRoute";
import HireRoute from "./Container/HireRoute";
import LoginRoute from "./Container/LoginRoute";
import TagManager from 'react-gtm-module';
import { GOOGLE_TAGMANAGER } from "./main_config";
import SuccessfulHiring from "./components/Hire/SuccessfulHiring";
import UnsuccessfulHiring from "./components/Hire/UnsuccessfulHiring"
import ProductInit from "./components/ProductInit"

const Home = lazy(() => import("./routes/home"));
const ProductsConsult = lazy(() => import("./routes/products/consult"));
const ProductsHire = lazy(() => import("./routes/products/hire"));
const ProductHired = lazy(() => import("./routes/products/hired"));
const Notes = lazy(() => import("./routes/notes"));
const Hire = lazy(() => import("./routes/hire"));
const Note = lazy(() => import("./routes/notes/note"));
const BranchesOffices = lazy(() => import("./routes/branchOffices"));
const Login = lazy(() => import("./routes/login"));
const RecoverAccount = lazy(() => import("./routes/recoverAccount"));
const Registration = lazy(() => import("./routes/registration"));
const Profile = lazy(() => import("./routes/profile"));
const Unsubscribe = lazy(() => import("./routes/Unsubscribe"));
const Repentance = lazy(() => import("./routes/repentance"));
const MedicalLeave = lazy(() => import("./routes/gpc/medicalLeave"));
const GPCSuccess = lazy(() => import("./routes/gpc/success"));
const Authenticity = lazy(() => import("./routes/gpc/authenticity"));
const Asociate = lazy(() => import("./routes/asociate"));

GOOGLE_TAGMANAGER.ID && TagManager.initialize({
  gtmId: GOOGLE_TAGMANAGER.ID,
  auth: GOOGLE_TAGMANAGER.AUTH,
  preview: GOOGLE_TAGMANAGER.PREVIEW_ENV
});

const App = () => {
  return <Provider store={store}>
    <ThemeProvider theme={eccoTheme}>
      <LoadingIndicatorProvider>
        <CssBaseline />
        <PersistGate loading={null} persistor={persistor}>
          <Router basename={"/individuales"}>
            <Suspense fallback={"."}>
              <Switch>
                <SimpleRoute exact path="/" component={Home} isHome={true} />
                <Route
                  path="/productos"
                  render={() => <Redirect to={{
                    pathname: "/st/productos"
                  }} />}
                  exact
                /> 
                <SimpleRoute
                  path="/productos/contratar/inicio"
                  component={ProductInit}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/productos/contratar/:modulo"
                  component={ProductsHire}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/productos/contratado"
                  component={ProductHired}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/productos/finalizado"
                  component={SuccessfulHiring}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/productos/pendiente"
                  component={UnsuccessfulHiring}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/productos/consulta/:prod?"
                  component={ProductsConsult}
                  isProduct={true}
                  LayoutProps={{
                    isProduct: true
                  }}
                />
                <SimpleRoute
                  path="/gpc"
                  component={MedicalLeave}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    showFloatsButtons: false
                  }}
                />
                <SimpleRoute
                  path="/e/gpc/success"
                  component={GPCSuccess}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    showFloatsButtons: false
                  }}
                />
                <SimpleRoute
                  path="/e/gpc/controlausentismo"
                  component={MedicalLeave}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    showFloatsButtons: false
                  }}
                />
                <PanelRoute
                  exact
                  path="/panel/:action?/:subAction?"
                  component={Profile}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    profileHeader: true,
                    showFloatsButtons: false
                  }}
                />
                {/*<HireRoute
                  exact
                  path="/contratenos"
                  component={Hire}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    profileHeader: true
                  }}
                />*/}
                <NestingRoute
                  path="/st/productos/:prod"
                  component={() => <Iframe file="productos" title="Productos"/>}
                  scrollTop={false}
                  nesting={[
                    {
                      path: "/consulta",
                      component: ProductsConsult,
                      exact: false
                    }
                  ]}
                />
                <SimpleRoute
                  exact
                  path="/st/:file"
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                  component={props => (
                    <Iframe file={props.computedMatch.params.file} />
                  )}
                />
                <NestingRoute
                  path="/notas"
                  component={Notes}
                  isNotes={true}
                  nesting={[
                    {
                      path: "/:slug",
                      component: Note,
                      exact: true,
                      isHome: false,
                      isNotes: false
                    }
                  ]}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <SimpleRoute
                  exact
                  path="/sucursales"
                  component={BranchesOffices}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <LoginRoute
                  exact
                  path="/login"
                  component={Login}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    showFloatsButtons: false
                  }}
                />
                <SimpleRoute
                  exact
                  path="/recuperar-cuenta"
                  component={RecoverAccount}
                  LayoutProps={{
                    noHeader: true,
                    noFooter: true,
                    showFloatsButtons: false
                  }}
                />
                <SimpleRoute
                  exact
                  path="/registracion"
                  component={Registration}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <SimpleRoute
                  exact
                  path="/solicitud-baja"
                  component={Unsubscribe}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <SimpleRoute
                  exact
                  path="/solicitud-arrepentimiento"
                  component={Repentance}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <Route
                  path="/asociate"
                  component={Asociate}
                  LayoutProps={{
                    showFloatsButtons: true
                  }}
                />
                <Route path="*" render={() => <Redirect to={{
                  pathname: "/"
                }} />} />
              </Switch>
            </Suspense>
          </Router>
        </PersistGate>
      </LoadingIndicatorProvider>
    </ThemeProvider>
  </Provider>
};

export default App;
